if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"HCIDWebsite","remotes":[{"alias":"HCIDPosLocator","name":"HCIDPosLocator","entry":"https://api-uat.homecredit.co.id/pos-locator-web/remoteEntry.js","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return !/^(2(241|346|97)|9(030|473|710)|(358|567|639|696)1|1823|4480|5445)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}